var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H13",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32812 14.4898L9.70813 11.3998C10.0481 10.9598 10.6781 10.8798 11.1181 11.2198L12.9482 12.6598C13.3882 12.9998 14.0181 12.9198 14.3581 12.4898L16.6682 9.50977",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4812 15.8204L19.7612 16.3904C19.9012 16.6704 20.2512 16.9304 20.5612 16.9904L20.9412 17.0504C22.0812 17.2404 22.3512 18.0804 21.5312 18.9104L21.1812 19.2604C20.9512 19.5004 20.8212 19.9604 20.8912 20.2804L20.9412 20.4904C21.2512 21.8704 20.5212 22.4004 19.3212 21.6804L19.0612 21.5304C18.7512 21.3504 18.2512 21.3504 17.9412 21.5304L17.6812 21.6804C16.4712 22.4104 15.7412 21.8704 16.0612 20.4904L16.1112 20.2804C16.1812 19.9604 16.0512 19.5004 15.8212 19.2604L15.4712 18.9104C14.6512 18.0804 14.9212 17.2404 16.0612 17.0504L16.4412 16.9904C16.7412 16.9404 17.1012 16.6704 17.2412 16.3904L17.5212 15.8204C18.0612 14.7304 18.9412 14.7304 19.4812 15.8204Z",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteChart);
export default __webpack_public_path__ + "static/media/favorite-chart.469223fcdfde28176822891b57f9c0ac.svg";
export { ForwardRef as ReactComponent };